import React, { FunctionComponent } from 'react';
import Page from '@/components/layout/Page';
import DestinationLinkIndex from '@/components/landingPages/LandingPageLinkIndex';
import Header from '@/components/typography/Header';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';

interface IProps {
  title: string;
  items: ILandingPageLink[];
}

const RegionsIndexPage: FunctionComponent<IProps> = ({ title, items }) => (
  <Page>
    <Header level={1} style={{ fontSize: 44 }}>
      {title}
    </Header>
    <DestinationLinkIndex items={items} />
  </Page>
);

export default RegionsIndexPage;
